export default __webpack_public_path__ + "3e22abde12ff416aeeed6345990411ed.png";